import { Box, Stack } from "@mui/system";
import { Typography } from "@mui/material";
import {
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import DecreaseDailyIncomeCard from "./DecreaseDailyIncomeCard";

const DecreaseDailyIncomeItem = ({
  sortedData = [],
}: {
  sortedData?: Record<string, any>[];
}) => {
  if (!sortedData?.length) {
    return (
      <Box sx={{ mt: spacing.Spacing.xl.$value, textAlign: "center" }}>
        <Typography sx={{ fontSize: typography.Size.Text.sm.$value }}>
          No data found
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
      <Stack spacing={2}>
        {sortedData.map((item, index) => (
          <DecreaseDailyIncomeCard
            key={`${item.brand_id ?? "row"}-${index}`}
            brand_name={item.brand_name}
            brand_id={item.brand_id}
            month={item.month}
            decreasedBy={item.max_minus_current_totalincome}
            maxReportedIncome={item.max_reported_income}
            currentTotalIncome={item.current_totalincome}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default DecreaseDailyIncomeItem;
